import { Component, Inject } from "@angular/core";
import { DatePipe, Time } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { User } from "../../../dataTypes/user";
import { editPermissionTranslatePipe } from "../../../common/pipes/editPermissionsTranslate";
import { visibilityPermissionsTranslatePipe } from "../../../common/pipes/visibilityPermissionsTranslate";
import { GuestsService } from "../../../services/GuestsService";
import { ParkForReservedSubscriber } from "../../../dataTypes/ParkForReservedSubscriber";



@Component({
  selector: 'editUser-dialog',
  templateUrl: './editUser.dialog.html',
})
export class EditUserDialog {


  visibilityPermissionsComboList: string[] = [
    'אורחים', 'מנויים', 'אורחים ומנויים'];

  editPermissionsComboList: string[] = [
    'עיון בלבד', 'עדכון'];

  _selectedVisibilityPermission: string;
  _selectedEditPermission: string;
  _selectedEditPermissionIsEdit: boolean;
  public _errorString: string;
  public _isAtidim: boolean;
  public _editPermissionsForParksComboList: ParkForReservedSubscriber[];
  public _selectedPark: ParkForReservedSubscriber;


  constructor(
    private datePipe: DatePipe,
    public dialogRef: MatDialogRef<EditUserDialog>,
    private _editPermissionTranslatePipe: editPermissionTranslatePipe,
    private _visibilityPermissionsTranslatePipe: visibilityPermissionsTranslatePipe,
    private _GuestsService: GuestsService,
    @Inject(MAT_DIALOG_DATA) public _EditUsertDialogModel: { selectedUser: User }) {//public data: {name: string}


    this._selectedEditPermission = this.editPermissionsComboList.find(x => x === _editPermissionTranslatePipe.transform(_EditUsertDialogModel.selectedUser.editPermissions));

    this._selectedVisibilityPermission = this.visibilityPermissionsComboList.find(x => x === _visibilityPermissionsTranslatePipe.transform(_EditUsertDialogModel.selectedUser.visibilityPermissions));

    if (this._selectedEditPermission === 'עיון בלבד') this._selectedEditPermissionIsEdit = false;
    if (this._selectedEditPermission === 'עדכון') this._selectedEditPermissionIsEdit = true;

    this._isAtidim = false;
    this.getOverflowLevels();
    this.getParks();
  }



  getOverflowLevels() {

    const self = this;

    self._GuestsService.getOverflowLevels()
      .subscribe((data: boolean) => {

        if (data === true) {
          self._isAtidim = true;
        }
        else self._isAtidim = false;
      },
        error => { }
      );
  }

  getParks() {

    const self = this;

    self._GuestsService.getAllParks()
      .subscribe((data: ParkForReservedSubscriber[]) => {

        self._editPermissionsForParksComboList = data;
        let park = new ParkForReservedSubscriber();
        park.id = -1;
        park.parkDescription = 'הכל';
        self._editPermissionsForParksComboList.unshift(park);
        self._selectedPark = self._editPermissionsForParksComboList[0];

        if (self._EditUsertDialogModel.selectedUser.id > 0 && self._isAtidim === true) {

          self._selectedPark = self._editPermissionsForParksComboList.find(x => x.id === self._EditUsertDialogModel.selectedUser.parkID);
        }
        if (self._selectedPark === undefined) self._selectedPark = self._editPermissionsForParksComboList[0];
      },
        error => { }
      );
  }


  onSelectedEditPermissionSelected(data) {

    if (this._selectedEditPermission === 'עיון בלבד') this._selectedEditPermissionIsEdit = false;
    if (this._selectedEditPermission === 'עדכון') this._selectedEditPermissionIsEdit = true;
  }

  onSaveClick(): void {


    if (this.InputFieldsAreValid() === true) {

      if (this._selectedEditPermission === 'עיון בלבד') this._EditUsertDialogModel.selectedUser.editPermissions = 1;
      if (this._selectedEditPermission === 'עדכון') this._EditUsertDialogModel.selectedUser.editPermissions = 0;

      if (this._selectedVisibilityPermission === 'אורחים') this._EditUsertDialogModel.selectedUser.visibilityPermissions = 1;
      if (this._selectedVisibilityPermission === 'מנויים') this._EditUsertDialogModel.selectedUser.visibilityPermissions = 2;
      if (this._selectedVisibilityPermission === 'אורחים ומנויים') this._EditUsertDialogModel.selectedUser.visibilityPermissions = 0;

      this._EditUsertDialogModel.selectedUser.parkID = this._selectedPark.id;

      this.dialogRef.close(this._EditUsertDialogModel.selectedUser);

    }
    else {
      // show alert

    }
  }

  onNoClick(): void {

    this.dialogRef.close();
  }

  InputFieldsAreValid(): boolean {


    if (!this._EditUsertDialogModel.selectedUser.username) {
      this._errorString = 'usernameCannotBeEmpty', 'error';
      return;
    }

    if (this._EditUsertDialogModel.selectedUser.id == 0 && !this._EditUsertDialogModel.selectedUser.password) {
      this._errorString = 'passwordCannotBeEmpty', 'error';
      return;
    }

    if (!this._selectedVisibilityPermission) {
      this._errorString = 'visibilityPermissionsCannotBeEmpty', 'error';
      return;
    }

    if (!this._selectedEditPermission) {
      this._errorString = 'editPermissionsCannotBeEmpty', 'error';
      return;
    }


    return true;
  }
}

 
